/* hb-np2.js · neck-proof-trudi v2 (sections/hb-np2-*), built from the approved prototype (9 Oct 2026).
   Own file: no shared hb-lp-* file is changed. Cart / tagging logic is copied from assets/hb-lp.js (read-only reference),
   so behaviour matches the tested pages: hb_lp + hb_lp_ad cart attributes stamped before the add, hidden _hb_lp line property, one serum line,
   cart drawer opened via the theme's cart-drawer element. Gift tiles are display only (Shopify Flow sends the gifts),
   so no gift line is ever added here. */
(function () {
  'use strict';
  var d = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hbLp = d.body.getAttribute('data-hblp-page') || '';
  var hbLpAd = '';
  try { hbLpAd = (new URLSearchParams(location.search).get('hb_lp') || '').toLowerCase(); } catch (e) {}
  if (!/^[a-z0-9_]{1,64}$/.test(hbLpAd)) hbLpAd = '';
  function track(section) {
    try { if (typeof window.clarity === 'function') window.clarity('event', 'lp_cta_' + section); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('hb_lp_cta_click', { opener: 'np2', section: section, hb_lp: hbLp, hb_lp_ad: hbLpAd }); } catch (e) {}
  }

  /* ---- no Alia on this template (12 Oct 2026). hb-np2.css hides #alia-root-* (popup + side tab); Alia still opens
     its popup invisibly and can lock the page. Undo only a lock that Alia set: release runs only while an Alia dialog
     ([id^="alia-root"] with role="dialog" on the root or on a child) is mounted, and only within 1.5 s of that dialog
     appearing or of any change inside an Alia root, so later locks from other modals (Loox gallery, Richpanel, Klaviyo) are left alone. Handles the inline
     overflow:hidden lock on <body> and <html> and the iOS body position:fixed lock (scroll position restored).
     The cart drawer's lock (body.overflow-hidden class) is never touched: only inline styles are. (M2, 12 Oct review) ---- */
  (function () {
    var b = d.body, h = d.documentElement;
    if (!b.classList.contains('template-page-neck-proof-trudi-v2') || !window.MutationObserver) return;
    var SEL = '[id^="alia-root"][role="dialog"],[id^="alia-root"] [role="dialog"],[id^="alia-root"] [aria-modal="true"]';
    var seenAt = 0, had = false;
    function dialog() { var on = !!d.querySelector(SEL); if (on && !had) seenAt = Date.now(); had = on; return on; }
    function unlock() {
      if (!dialog() || Date.now() - seenAt > 1500) return;
      if (h.style.overflow === 'hidden') h.style.removeProperty('overflow');
      if (b.style.overflow === 'hidden') b.style.removeProperty('overflow');
      if (b.style.position === 'fixed') {
        var y = -parseInt(b.style.top || '0', 10) || 0;
        ['position', 'top', 'left', 'right', 'width'].forEach(function (k) { b.style.removeProperty(k); });
        if (y > 0) window.scrollTo(0, y);
      }
    }
    function soon() { unlock(); setTimeout(unlock, 0); setTimeout(unlock, 300); setTimeout(unlock, 1000); }
    var mo = new MutationObserver(soon);
    mo.observe(b, { attributes: true, attributeFilter: ['style'] });
    mo.observe(h, { attributes: true, attributeFilter: ['style'] });
    /* Alia mounting (or flipping role on) its dialog also starts the 1.5 s window */
    new MutationObserver(function (ms) {
      /* any activity inside an Alia root (popup opening later on a timer / scroll / exit intent) restarts the window (review N3) */
      for (var i = 0; i < ms.length; i++) { var t = ms[i].target; if (t.closest && t.closest('[id^="alia-root"]')) { seenAt = Date.now(); break; } }
      if (!had && dialog()) soon(); else if (had) dialog();
    }).observe(b, { childList: true, subtree: true, attributes: true, attributeFilter: ['role', 'aria-modal'] });
    soon();
  })();

  /* ---- s04 callout diagram: hotspots + leader line placed relative to the tube (prototype logic) ---- */
  (function () {
    var f = d.querySelector('.np3-s4__fig'); if (!f) return;
    function place() {
      var t = f.querySelector('.np3-s4__tube'), fr = f.getBoundingClientRect(), tr = t.getBoundingClientRect();
      if (!tr.height) return;
      var cx = tr.left - fr.left + tr.width / 2, top = tr.top - fr.top, h = tr.height;
      var h1 = f.querySelector('.hs1'), h2 = f.querySelector('.hs2'), h3 = f.querySelector('.np3-s4__hs:not(.hs1):not(.hs2)');
      h3.style.left = (cx - 14) + 'px'; h3.style.top = (top + h * 0.40 - 14) + 'px';
      h2.style.left = (cx + tr.width * 0.30 - 14) + 'px'; h2.style.top = (top + h * 0.80 - 14) + 'px';
      h1.style.left = (cx - 14) + 'px'; h1.style.top = (top + h * 0.985 - 14) + 'px';
      var z = f.querySelector('.np3-s4__zoom').getBoundingClientRect(), l = f.querySelector('svg.lead line');
      l.setAttribute('x1', cx + 16); l.setAttribute('y1', top + h * 0.985); l.setAttribute('x2', z.left - fr.left + z.width * 0.18); l.setAttribute('y2', z.top - fr.top + z.height * 0.5);
    }
    place(); window.addEventListener('resize', place); if (d.fonts) d.fonts.ready.then(place); window.addEventListener('load', place);
    var img = f.querySelector('.np3-s4__tube'); if (img && !img.complete) img.addEventListener('load', place);
  })();

  /* ---- s05 before/after slider (12 Oct 2026 rework): the whole surface is draggable and tappable.
     Mouse: press moves the divider and drags. Touch/pen: nothing moves until the gesture is read, so a vertical
     swipe still scrolls the page (touch-action: pan-y) without jerking the divider; a horizontal move drags; a tap
     glides the divider to the tap point. A tap on the divider itself (where it already is) gives a small nudge so
     the tap visibly responds. Touch events are a fallback for webviews without Pointer Events. Keyboard arrows kept. */
  d.querySelectorAll('[data-np2-ba]').forEach(function (el) {
    var tracked = false, st = null, animT = 0, nudgeT = 0;
    function cur() { return +el.getAttribute('aria-valuenow') || 0; }
    function set(p) { p = Math.max(0, Math.min(100, p)); el.style.setProperty('--pos', p + '%'); el.setAttribute('aria-valuenow', Math.round(p)); }
    function pct(x) { var r = el.getBoundingClientRect(); return r.width ? (x - r.left) / r.width * 100 : cur(); }
    function anim(on) { clearTimeout(animT); el.classList.toggle('is-anim', !!on && !reduce); if (on) animT = setTimeout(function () { el.classList.remove('is-anim'); }, 320); }
    function first() { if (!tracked) { tracked = true; track('np2_slider'); } }
    function tapAt(x) {
      var p = pct(x), c = cur(); first();
      if (Math.abs(p - c) < 6) { var n = c > 50 ? c - 12 : c + 12; anim(true); set(n); clearTimeout(nudgeT); nudgeT = setTimeout(function () { anim(true); set(p); }, 300); }
      else { anim(true); set(p); }
    }
    function start(x, y, kind) { clearTimeout(nudgeT); st = { x: x, y: y, drag: kind === 'mouse' }; if (st.drag) { anim(false); set(pct(x)); first(); } }
    function move(x, y) {
      if (!st) return false;
      if (!st.drag) { var dx = Math.abs(x - st.x), dy = Math.abs(y - st.y); if (dx > 6 && dx > dy) { st.drag = true; anim(false); first(); } else if (dy > 10) { st = null; return false; } }
      if (st && st.drag) { set(pct(x)); return true; }
      return false;
    }
    function end(x, y) { if (!st) return; var s0 = st; st = null; if (!s0.drag && Math.abs(x - s0.x) < 10 && Math.abs(y - s0.y) < 10) tapAt(x); }
    if (window.PointerEvent) {
      el.addEventListener('pointerdown', function (e) { if (e.button > 0) return; try { el.setPointerCapture(e.pointerId); } catch (er) {} start(e.clientX, e.clientY, e.pointerType); });
      el.addEventListener('pointermove', function (e) { if (st && e.pointerType === 'mouse' && !(e.buttons & 1)) { st = null; return; } move(e.clientX, e.clientY); });
      el.addEventListener('pointerup', function (e) { end(e.clientX, e.clientY); });
      el.addEventListener('pointercancel', function () { st = null; });
      el.addEventListener('lostpointercapture', function () { if (st && st.drag) st = null; });
    } else {
      el.addEventListener('touchstart', function (e) { var t = e.touches[0]; start(t.clientX, t.clientY, 'touch'); }, { passive: true });
      el.addEventListener('touchmove', function (e) { var t = e.touches[0]; if (move(t.clientX, t.clientY) && e.cancelable) e.preventDefault(); }, { passive: false });
      el.addEventListener('touchend', function (e) { var t = e.changedTouches[0]; end(t.clientX, t.clientY); });
      el.addEventListener('touchcancel', function () { st = null; });
      el.addEventListener('mousedown', function (e) { start(e.clientX, e.clientY, 'mouse'); var mm = function (ev) { move(ev.clientX, ev.clientY); }, mu = function () { st = null; d.removeEventListener('mousemove', mm); d.removeEventListener('mouseup', mu); }; d.addEventListener('mousemove', mm); d.addEventListener('mouseup', mu); });
    }
    el.addEventListener('keydown', function (e) { var v = cur(); if (e.key === 'ArrowLeft') { set(v - 5); e.preventDefault(); } if (e.key === 'ArrowRight') { set(v + 5); e.preventDefault(); } });
  });

  /* ---- videos: play button starts; tap/click on the playing video pauses/resumes; overlay back on pause/end (same as the 9 Oct hb-lp fix) ---- */
  d.querySelectorAll('[data-np2-video]').forEach(function (card) {
    var v = card.querySelector('video'), b = card.querySelector('.np3-vid__play');
    if (!v || !b) return;
    v.controls = false; v.setAttribute('playsinline', ''); v.playsInline = true;
    function start() {
      d.querySelectorAll('video').forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
      card.classList.add('is-playing'); card.classList.remove('is-paused');
      v.setAttribute('tabindex', '0');
      var p = v.play(); if (p && p.catch) p.catch(function () { card.classList.add('is-paused'); });
    }
    function toggle() { if (v.paused || v.ended) start(); else v.pause(); }
    b.addEventListener('click', function () { var first = !card.classList.contains('is-playing'); start(); try { v.focus({ preventScroll: true }); } catch (e) {} if (first) track('np2_video'); });
    v.addEventListener('click', function (e) { if (!card.classList.contains('is-playing')) return; e.preventDefault(); toggle(); });
    v.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter' || e.key === 'k') { e.preventDefault(); toggle(); } });
    v.addEventListener('play', function () { card.classList.add('is-playing'); card.classList.remove('is-paused'); });
    v.addEventListener('pause', function () { if (card.classList.contains('is-playing')) card.classList.add('is-paused'); });
    v.addEventListener('ended', function () { card.classList.add('is-paused'); });
  });

  /* ---- fixed AUD amounts (shipping value, free-shipping threshold) in the shopper's currency: AUD amount x Shopify.currency.rate,
     rounded up to a whole unit like the Markets-rounded prices on this page; formatted with the currency's own money format (data-np2-fmt = 1 unit) ---- */
  (function () {
    var cur = window.Shopify && window.Shopify.currency, rate = cur ? parseFloat(cur.rate) : 1;
    if (!(rate > 0)) rate = 1;
    d.querySelectorAll('[data-np2-aud]').forEach(function (el) {
      if (el.textContent.trim()) return;
      var v = Number(el.getAttribute('data-np2-aud')) / 100 * rate;
      v = Math.ceil(v - 1e-9);
      var fmt = el.getAttribute('data-np2-fmt') || '';
      el.textContent = /1/.test(fmt) ? fmt.replace('1', String(v)) : String(v);
    });
  })();

  /* ---- copy-link share button ---- */
  d.querySelectorAll('[data-np2-copy]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); var u = location.origin + location.pathname; try { navigator.clipboard.writeText(u); a.setAttribute('aria-label', 'Link copied'); } catch (er) {} });
  });

  /* ---- "Read all reviews": open the full Loox widget under the comment wall (created only on demand; loox.js picks up #looxReviews) ---- */
  var panel = d.getElementById('np2-reviews');
  d.addEventListener('click', function (e) {
    var a = e.target.closest('[data-np2-reviews]'); if (!a || !panel) return;
    e.preventDefault();
    panel.hidden = false;
    var w = panel.querySelector('[data-np2-loox]');
    if (w && !d.getElementById('looxReviews')) { w.id = 'looxReviews'; track('np2_reviews_all'); }
    panel.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---- s11 FAQ accordions (first open) ---- */
  d.querySelectorAll('.np3-fq button').forEach(function (b) {
    b.addEventListener('click', function () { var q = b.closest('.np3-fq'), on = !q.classList.contains('on'); q.classList.toggle('on', on); b.setAttribute('aria-expanded', String(on)); });
  });

  /* ---- sticky bar ("See the offer"): on after the hero CTA has scrolled above the screen, off while the offer section is on screen ---- */
  (function () {
    var bar = d.querySelector('[data-np2-sticky]'), hero = d.querySelector('[data-hblp-cta="np2_hero"]'), offer = d.getElementById('offer');
    if (!bar || !hero) return;
    var on = null, ticking = false;
    var fin = d.querySelector('[data-hblp-cta="np2_final_atc"]'); fin = fin && (fin.closest('.shopify-section') || fin.closest('section'));
    /* measured on scroll/resize (not IntersectionObserver), so jumps like scrollTo(0) or anchor links can't leave it stale */
    function sync() {
      ticking = false;
      var vh = window.innerHeight, hr = hero.getBoundingClientRect(), past = hr.bottom < 0, inOffer = false;
      /* arm B of the CTA test hides #offer: then the bar steps aside while the final CTA section is on screen (L6) */
      var zone = offer && offer.getClientRects().length ? offer : fin;
      if (zone) { var o = zone.getBoundingClientRect(); inOffer = o.top < vh * 0.95 && o.bottom > vh * 0.05; }
      var next = past && !inOffer;
      if (next === on) return; on = next;
      bar.classList.toggle('is-on', on);
      d.body.classList.toggle('np2-sticky-up', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }
    function req() { if (!ticking) { ticking = true; requestAnimationFrame(sync); } }
    window.addEventListener('scroll', req, { passive: true }); window.addEventListener('resize', req); sync();
    var go = bar.querySelector('[data-np2-sticky-btn]');
    /* height of any fixed/sticky header pinned to the top of the screen (none on this page today, but the layout could add one) */
    function headerOffset() {
      var off = 0, seen = [];
      [0.1, 0.5, 0.9].forEach(function (fx) {
        (d.elementsFromPoint ? d.elementsFromPoint(window.innerWidth * fx, 1) : []).forEach(function (el) {
          for (var e = el; e && e !== d.body && e !== d.documentElement; e = e.parentElement) {
            if (seen.indexOf(e) > -1 || bar.contains(e)) continue; seen.push(e);
            var ps = getComputedStyle(e).position;
            if (ps === 'fixed' || ps === 'sticky') { var r = e.getBoundingClientRect(); if (r.top <= 1 && r.bottom > off && r.height < window.innerHeight / 2) off = r.bottom; }
          }
        });
      });
      return Math.round(off);
    }
    if (go && offer) go.addEventListener('click', function (e) {
      e.preventDefault();
      var y = offer.getBoundingClientRect().top + window.pageYOffset - headerOffset();
      window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
      var h = offer.querySelector('h2') || offer;
      if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
      try { h.focus({ preventScroll: true }); } catch (x) { h.focus(); }
    });
  })();

  /* ---- s09 offer: plan toggle, gallery thumbs, add to cart ---- */
  var box = d.querySelector('[data-np2-offer]'), form = d.getElementById('np2Buy');
  /* 15 Oct: the hero offer card adds through this buy box; if the box is missing or its prices / plan / gift value differ, drop the card */
  var hoCard = d.querySelector('[data-np2-ho]');
  if (hoCard && (!box || !form || ['sub', 'one', 'plan', 'gifts'].some(function (k) { return hoCard.getAttribute('data-' + k) !== box.getAttribute('data-' + k); }))) {
    hoCard.parentNode.removeChild(hoCard);
    try { if (typeof window.clarity === 'function') window.clarity('event', 'hero_offer_mismatch'); } catch (x) {}
  }
  if (!box || !form) return;
  var cta = d.getElementById('npCta'), planInput = form.querySelector('[data-np2-plan-input]'), msg = form.querySelector('[data-np2-msg]');
  var SUB = box.getAttribute('data-sub'), ONE = box.getAttribute('data-one'), PLAN = box.getAttribute('data-plan');
  function plan() { var r = form.querySelector('input[name=np3plan]:checked'); return r ? r.value : 'sub'; }
  function upd() {
    var p = plan();
    box.querySelectorAll('.np3-opt').forEach(function (o) { o.classList.toggle('on', o.getAttribute('data-plan') === p); });
    cta.innerHTML = p === 'sub' ? 'Add to cart · ' + SUB + ' <s>' + ONE + '</s>' : 'Add to cart · ' + ONE;
    if (planInput) { planInput.value = p === 'sub' ? PLAN : ''; planInput.disabled = p !== 'sub'; }
    /* sticky bar: gifts text only for Subscribe */
    d.querySelectorAll('[data-np2-sticky-gifts]').forEach(function (g) { g.hidden = p !== 'sub'; });
    /* renewal note under Add to cart: Subscribe only (JS, so browsers without :has() hide it on One-time too; L5) */
    form.querySelectorAll('[data-np2-renew]').forEach(function (n) { n.hidden = p !== 'sub'; });
  }
  form.querySelectorAll('input[name=np3plan]').forEach(function (r) { r.addEventListener('change', upd); });
  upd();
  box.querySelectorAll('.np3-of__th button').forEach(function (b) {
    b.addEventListener('click', function () {
      box.querySelectorAll('.np3-of__th button').forEach(function (x) { x.classList.remove('on'); });
      b.classList.add('on'); var m = d.getElementById('npOfImg'); if (m) m.src = b.getAttribute('data-src');
    });
  });

  var busy = false;
  function post(url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) }); }
  /* one serum line: add first, then drop older serum lines (a failed add never removes anything).
     12 Oct 2026: "older serum lines" also covers OTHER neck-serum products/variants (e.g. a one-time $40 line left from an
     earlier PDP visit), so the cart holds exactly the option chosen here. Review fixes (12 Oct): serum products matched by
     product ID, not handle (L2); never touched: $0 lines (checked first, L1), gift lines (_gift / _offer_gift), offer-gift
     qualifiers (_gift_offer, whose gifts hb-cart.js would drop with them, M3) and lines with bundle properties. */
  var SERUM_PIDS = [
    8371340148907, /* collagen-hemp-neck-firming-serum (base) */
    8825842598059, /* collagen-hemp-neck-firming-serum-2 */
    9047599415467, /* collagen-hemp-neck-firming-serum-3 (Variant B) */
    8754849054891, /* neck-firming-60-day-supply */
    8752296853675, /* neck-firming-90-day-supply */
    8751540928683, /* collagen-hemp-neck-firming-serum-factor */
    8825895092395  /* collagen-hemp-neck-firming-serum-no-subscription */
  ];
  function isOldSerum(li, id) {
    var pr = li.properties || {};
    if (!(li.final_line_price > 0)) return false;
    if (pr._gift === 'true' || pr._offer_gift || pr._gift_offer) return false;
    if (Object.keys(pr).some(function (k) { return /bundle/i.test(k); })) return false;
    return li.variant_id === id || SERUM_PIDS.indexOf(li.product_id) > -1;
  }
  function addSingleton(item) {
    return fetch('/cart.js?_=' + Date.now(), { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      var old = (cart.items || []).filter(function (li) { return isOldSerum(li, item.id); });
      return post('/cart/add.js', { items: [item] }).then(function (r) { return r.json(); }).then(function (res) {
        if (res && res.status) { var se = new Error(res.description || res.message || ''); se.userFacing = true; throw se; }
        var newKey = res.items && res.items[0] && res.items[0].key, updates = {}, n = 0;
        old.forEach(function (li) { updates[li.key] = li.key === newKey ? 1 : 0; n++; });
        if (newKey && !(newKey in updates) && res.items[0].quantity > 1) { updates[newKey] = 1; n++; }
        if (!n) return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
        /* M1: a failed cleanup (HTTP error, {status} body or network) is not success; the add did happen, so flag it */
        return post('/cart/update.js', { updates: updates })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok || (j && j.status)) throw new Error('cleanup'); return j; }); })
          .catch(function () { var ce = new Error('cleanup'); ce.added = true; throw ce; });
      });
    });
  }
  function addToCart(trigger) {
    if (busy) return; busy = true;
    if (msg) msg.textContent = '';
    var hoM = d.querySelector('[data-np2-msg-ho]'); if (hoM) hoM.textContent = '';
    var btns = [cta].concat([].slice.call(d.querySelectorAll('[data-np2-atc]')));
    btns.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    var p = plan(), variantId = Number(form.elements.id.value), item = { id: variantId, quantity: 1 };
    if (p === 'sub' && PLAN) item.selling_plan = Number(PLAN);
    var lpProp = form.querySelector('[name="properties[_hb_lp]"]');
    if (lpProp && lpProp.value) item.properties = { _hb_lp: lpProp.value };
    var attrs = { bundle_source: '' };
    if (hbLp) { attrs.hb_lp = hbLp; attrs.hb_lp_ad = hbLpAd; }
    /* CTA A/B (spec 09): which arm the shopper was in (snippets/hb-np2-ab); stamped for split visits and, since 16 Oct (test ended), 'ended' visits (arm A) */
    /* 13 Oct (audit bugs 3/4): natural-split visits only, and with the arm's source */
    if (window.hbTrudiAb && window.hbTrudiAb.arm && (window.hbTrudiAb.src === 'split' || window.hbTrudiAb.src === 'ended')) { attrs.hb_trudi_arm = window.hbTrudiAb.arm; attrs.hb_trudi_arm_src = window.hbTrudiAb.src; }
    /* 15 Oct: hero offer card test (snippets/hb-np2-ho), natural-split visits only, same rule as the arm */
    if (window.hbTrudiHo && window.hbTrudiHo.v && window.hbTrudiHo.src === 'split') { attrs.hb_trudi_hero_offer = window.hbTrudiHo.v; attrs.hb_trudi_hero_offer_src = window.hbTrudiHo.src; }
    var drawer = d.querySelector('cart-drawer');
    var CART_URL = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/') + 'cart';
    function openCart() {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hb-np2', productVariantId: variantId });
      if (drawer && typeof drawer.open === 'function') { drawer.classList.remove('is-empty'); drawer.open(trigger || undefined); }
      else window.location.href = CART_URL;
    }
    post('/cart/update.js', { attributes: attrs }).catch(function () {})
      .then(function () { return addSingleton(item); })
      .then(openCart)
      .catch(function (err) {
        /* the add worked but removing the older line failed: show the real cart (the shopper can fix it there), no error */
        if (err && err.added) { try { openCart(); } catch (x) { window.location.href = CART_URL; } return; }
        var em = (err && err.userFacing && err.message) || 'Sorry, something went wrong. Please try again.';
        /* hero offer card: show the error in the card (the buy box may be hidden in arm B) */
        var hoMsg = trigger && trigger.closest && trigger.closest('[data-np2-ho]') ? d.querySelector('[data-np2-msg-ho]') : null;
        if (hoMsg) { hoMsg.textContent = em; return; }
        if (msg) msg.textContent = em;
        if (trigger && trigger !== cta && box.offsetParent) box.scrollIntoView({ block: 'center' });
      })
      .then(function () { busy = false; btns.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); }); });
  }
  form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(e.submitter || cta); });
  /* final CTA: adds the Subscribe offer it advertises ($49 + 3 gifts) */
  d.querySelectorAll('[data-np2-atc]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var r = form.querySelector('input[name=np3plan][value="' + (b.getAttribute('data-np2-atc') || 'sub') + '"]');
      if (r && !r.checked) { r.checked = true; upd(); }
      addToCart(b);
    });
  });
})();
